module.exports = __webpack_public_path__ + "static/media/LearnCreatorAlignment.4672c5fe.png";